import api from '@/services/api'

export const token = {
  namespaced: true,
  state: {
    isRefreshing: false,
    xsrf: null,
    refreshToken: null,
    validitySessionMinutes: null,
  },
  actions: {
    clear : ({ state, commit }) => {
      state.isRefreshing = false
      state.xsrf = null
      state.refreshToken = null
      state.validitySessionMinutes = null

      commit('clear')
    },
    refreshToken: async ({ state, commit }) => {
      if(state.isRefreshing === false) {
        commit('saveRefreshing', true)

        await api.post('/token/refresh', {
          refresh_token: state.refreshToken,
        }).then((response) => {
            commit('save', {
                'xsrf': response.data.xsrf_token,
                'refreshToken': response.data.refresh_token,
                'validitySessionMinutes': response.data.validity_session_minutes,
            })
        }).catch((e) => {
          console.log(e.response)
        })
      } else {
        const timeout = (ms) => {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
    
        const whileLoop = async () => {
          if(state.isRefreshing === true) {
            await timeout(100)
            await whileLoop() 
          }
          
          return false
        }
    
        await whileLoop()
      }
    }
  },
  mutations: {
    clear(state) {
      state.isRefreshing = false
      state.xsrf = null
      state.refreshToken = null
      state.validitySessionMinutes = null
    },
    saveRefreshing(state, isRefreshing) {
      state.isRefreshing = isRefreshing
    },
    save(state, connection) {
        if(connection.hasOwnProperty('xsrf')) {
            state.xsrf = connection.xsrf
        }

        if(connection.hasOwnProperty('refreshToken')) {
            state.refreshToken = connection.refreshToken
        }

        if(connection.hasOwnProperty('validitySessionMinutes')) {
          state.validitySessionMinutes = connection.validitySessionMinutes
        }

        state.isRefreshing = false
    },
  },
};
